import { render, staticRenderFns } from "./WeekDaysView.vue?vue&type=template&id=f5f54f5c&scoped=true"
import script from "./WeekDaysView.vue?vue&type=script&lang=js"
export * from "./WeekDaysView.vue?vue&type=script&lang=js"
import style0 from "./WeekDaysView.vue?vue&type=style&index=0&id=f5f54f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f54f5c",
  null
  
)

export default component.exports